import { icon, Icon } from '../lib/fa-icons.js';
/*
Place this widget just before the closing tag of the .Article__Main element
*/

import Widget from "./base.js";
import { getCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

export class MeteredBumperSummer26Widget extends Widget {
	componentWillMount() {
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;

		//look up the profile, if membership_was is set dont show this
		const profileData = this.getProfileData();
		const self = this;

		let views = getCookie("tpm_article_views");
		if (views === null) views = 0;
		else views = parseInt(views);
		//we DO want to count the first and current article view(s) but the pvt might not have got to it yet
		//(race condition). If didtrack is falsy increment the views to account for that
		if (!window.tpm_pvt || !window.tpm_pvt.didtrack) {
			views = views + 1;
		}

		this.state.views = views;

		this.toggleShrink = this.toggleShrink.bind(this);

		document
			.querySelector(".js_site-footer")
			.setAttribute("style", "padding-bottom: 100px");
	}

	componentDidMount() {
		window.mbw = this;
		window.addEventListener("scroll", this.scrollWatcher);
		document
			.querySelector("body")
			.setAttribute("style", "padding-bottom: 80px");
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		return getProfile();
	}

	scrollWatcher() {
		if (window.mbw.state.hideComponent) return;

		let el = document.querySelector(".js_article-content");
		if (mbw.props.fp) el = document.querySelector(".front-page");

		if (window.scrollY > el.getBoundingClientRect().top) {
			mbw.slideUp();
			window.removeEventListener("scroll", this.scrollWatcher);
		}
	}

	slideUp() {
		document
			.querySelector(".MeteredBumperSummer26Widget")
			.classList.add("--slide-up");
	}

	toggleShrink(e) {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ shrunk: !this.state.shrunk });
	}

	get countText() {
		return `You've read ${this.state.views} article${
			this.state.views > 1 ? "s" : ""
		} this month`;
	}

	get secondLevelDomain() {
		return document.location.hostname.split(".")[1];
	}

	href() {
		const source = "on_site";
		const campaign = "memberships_fall24";
		let medium = "bumper_article";
		if (this.props.fp) medium = "bumper_fp";
		const promo = this.state.views > 9 ? "&promo=tpm25" : "";

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}${promo}`;
	}

	get hrefDirect() {
		const promo = "&promo=PrimeAnnual38";
		return `https://accounts.talkingpointsmemo.com/membership?plan=prime_year${promo}`;
	}

	list() {
		return (
			<ul className="MeteredBumperSummer26__List">
				<li>Reader-funded</li>
				<li className="circle" aria-hidden="true"></li>
				<li>Unionized</li>
				<li className="circle" aria-hidden="true"></li>
				<li>Mission-driven</li>
			</ul>
		);
	}

	renderContent() {
		if (this.state.hideComponent) return;

		if (this.state.shrunk || document.body.getBoundingClientRect().width < 360)
			return (
				<div className={`MeteredBumperSummer26 ${this.props.fp ? "--fp" : ""} `}>
					<div
						className={`MeteredBumperSummer26__Inner ${
							this.props.thick ? "--thick" : ""
						}`}
					>
						<div className="MeteredBumperSummer26__Top --shrunk">
							<div className="MeteredBumperSummer26__Flex">
								<div className="MeteredBumperSummer26__Logo --shrunk">
									<div className="FundraiserLogo --smaller">
										<div class="underline"><span><span>The&nbsp;TPM</span></span></div>
										<div class="underline"><span><span>Journalism</span></span></div>
										<div class="underline"><span><span>Fund</span></span></div>
									</div>
								</div>
							
								<div className="MeteredBumperSummer26__Body --shrunk">
									<p className="big">Last Chance!</p>
								</div>

								<div className="MeteredBumperSummer26__Buttons">
									<a href={this.hrefDirect} className="Button --red">
										Join for only $38
									</a>
								</div>

								<div
									className="MeteredBumperSummer26__Shrink --shrunk"
									onClick={this.toggleShrink}
								>
									<Icon name={this.state.shrunk ? 'angle-up' : 'angle-down'} style="light" />
								</div>
							</div>
						</div>
					</div>
				</div>
			);

		return (
			<div className={` MeteredBumperSummer26 ${this.props.fp ? "--fp" : ""}`}>
				<div
					className={`MeteredBumperSummer26__Inner ${
						this.props.thick ? "--thick" : ""
					}`}
				>
					<div className="MeteredBumperSummer26__Top">
						<div
							className="MeteredBumperSummer26__Shrink"
							onClick={this.toggleShrink}
						>
							<Icon name={this.state.shrunk ? 'angle-up' : 'angle-down'} style="light" />
						</div>
					</div>
					<div className="MeteredBumperSummer26__Body">

						<p className="count">{this.countText}</p>

						<p className="big">Last Chance!</p>

						<p>We’ve hit our goal for the Journalism Fund Drive, but we’re continuing our membership sale through the end of the week.</p>

						<p>Join today and get <b>full-access annual membership for only $38. That’s a savings of nearly 50%.</b></p>

						<div className="MeteredBumperSummer26__Buttons --margin">
							<a href={this.hrefDirect} className="Button --red">
								Join for only $38
							</a>
						</div>

						<div class="MeteredBumperSummer26__Logo --lg">
							<div className="FundraiserLogo --smaller">
								<div class="underline"><span><span>The&nbsp;TPM</span></span></div>
								<div class="underline"><span><span>Journalism</span></span></div>
								<div class="underline"><span><span>Fund</span></span></div>
							</div>
						</div>

					</div>
				</div>
				<div className="MeteredBumperSummer26__SideSpacer"></div>
			</div>
		);
	}
}
